import React from "react";
import { useNavigate } from "react-router-dom";
import svg10 from "../../../../assets/svg/svg10.svg";

function WhyOrganizersLove({ why }) {
  const navigate = useNavigate();

  return (
    <div className="lg:px-[5.69rem] px-3 py-[2rem] lg:py-[4.62rem]">
      {/* Title */}
      <div className="text-[#202020] text-center font-lexend text-[2rem] lg:text-[3rem] font-[500] leading-[2.5rem] lg:leading-[3.375rem] tracking-[-0.06rem]">
        {why?.title}
      </div>

      {/* Features 2x2 grid */}
      <div className="mt-[3rem] grid grid-cols-1 sm:grid-cols-2 lg:px-[15rem] gap-x-[3rem] gap-y-[2rem]">
        {why?.features?.map((f, i) => (
          <div key={i} className="flex flex-row items-start gap-[.75rem]">
            <img src={f?.icon} alt={f?.title} className="w-[3rem] h-[3rem] flex-shrink-0" loading="lazy" />
            <div className="flex flex-col gap-[.25rem]">
              <div className="text-[#202020] font-lexend text-[1.125rem] font-[600] leading-[1.625rem] tracking-[-0.0135rem]">
                {f?.title}
              </div>
              <div className="text-[#7A7493] font-lexend text-[1rem] font-[400] leading-[1.625rem] tracking-[-0.0135rem]">
                {f?.desc}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Full-width image */}
      <div className="mt-[2.5rem]">
        <img
          src={why?.img}
          alt={why?.title}
          loading="lazy"
          className="w-full h-[25rem] object-contain rounded-[1.25rem]"
        />
      </div>

      {/* CTA */}
      <div className="mt-[2.5rem] flex justify-center">
        <button
          className="cstm-btn-2 !w-auto !min-w-0 group transition-all duration-500 ease-in-out"
          onClick={() => navigate("/request-demo")}
        >
          Request a demo
          <img
            src={svg10}
            alt="arrow"
            className="w-4 h-3 overflow-hidden opacity-0 group-hover:w-[1.25rem] group-hover:opacity-100 group-hover:ml-[.375rem] transition-all duration-500 ease-in-out"
          />
        </button>
      </div>
    </div>
  );
}

export default WhyOrganizersLove;
